module.exports = __webpack_public_path__ + "static/img/mini.ff97bfca.jpg";